import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-up",
  "use": "icon-chevron-up-usage",
  "viewBox": "0 0 18.7 10.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18.7 10.3\" id=\"icon-chevron-up\">\r\n<path d=\"M18.7,9.3c0,0.3-0.1,0.5-0.3,0.7c-0.4,0.4-1,0.4-1.4,0L9.3,2.4L1.7,10c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l8.3-8.3\r\n\tc0.4-0.4,1-0.4,1.4,0l8.3,8.3C18.6,8.8,18.7,9.1,18.7,9.3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol